import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { environment } from '@enviroment/environment';
import { AuthManagementService } from '@core/service/auth-management.service';
import { NavigationHistoryService } from '@core/service/navigation-history.service';
import Swal from 'sweetalert2';

export const regionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  const auth = inject(AuthManagementService);
  const navigationHistory = inject(NavigationHistoryService);

  const excludedRegions = ((route.data?.['excludeRegions'] ?? []) as string[])
    .map(region => String(region).trim().toUpperCase());

  if (!excludedRegions.length) return true;

  const currentRegion = String(environment.region ?? '').trim().toUpperCase();
  if (!currentRegion) return true;

  if (!excludedRegions.includes(currentRegion)) return true;

  const key = 'security_denied_access_audit';
  const raw = localStorage.getItem(key);
  const current = raw ? JSON.parse(raw) : [];
  const userData = auth.userData ? auth.userData() : null;

  current.push({
    date: new Date().toISOString(),
    reason: 'REGION_BLOCKED',
    routePath: route.routeConfig?.path ?? '',
    routerUrl: router.url,
    region: currentRegion,
    userId: userData?.IdUsuario ?? null,
    userRole: userData?.TipoUsuario ?? null
  });

  localStorage.setItem(key, JSON.stringify(current));
  console.log('REGION GUARD EJECUTADO');

  Swal.fire({
    icon: 'warning',
    title: 'ACCESO DENEGADO',
    text: 'NO TIENES PERMISOS PARA ACCEDER A ESTA SECCIÓN.',
    confirmButtonText: 'ACEPTAR'
  });

  const previousUrl = navigationHistory.getPreviousUrl();

  if (previousUrl && previousUrl !== router.url) {
    return router.parseUrl(previousUrl);
  }

  return router.createUrlTree([auth.getDefaultRoute()]);
};
